import React from 'react'
import { useEffect } from 'react'
import Header from '../common/Header'
import SideMenu from '../common/SideMenu'
import Tr from './Tr';

import './RefundQueue.css'
import { useTranslation } from "react-i18next";
import { fetchRefundQueue, completeRefund } from '../../../utils/apiClient';

/**
 * オーバーセル返金キュー（refund_queue）管理画面。#61
 * ベンダーが即時返金するが、取りこぼし監視のため運営が毎営業日 pending を確認し、
 * 手動返金済みのものを「完了」マークする（markCompleted のフォールバック）。
 */
const RefundQueue = () => {
  const { t } = useTranslation();

  const [list, setList] = React.useState([]);
  const [pendingCount, setPendingCount] = React.useState(0);
  const [state, setState] = React.useState('pending');
  const [reloadKey, setReloadKey] = React.useState(0);

  useEffect(() => {
    const params = new URLSearchParams();
    if (state) params.append('state', state);

    fetchRefundQueue(params.toString())
      .then(async response => {
        const data = await response.json().catch(() => ({}));
        if (!response.ok) {
          alert(data.message || t('common.error'));
          return;
        }
        if (data?.errors) {
          alert(Object.values(data.errors)[0]);
          return;
        }
        setList(data?.data || []);
        setPendingCount(data?.meta?.pending_count ?? 0);
      })
      .catch(error => {
        console.error(error);
      });
  }, [state, reloadKey]);

  const onComplete = async (id) => {
    if (!window.confirm(t('refund_queue.confirm_complete'))) return;
    try {
      const res = await completeRefund(id);
      if (res.ok) {
        alert(t('refund_queue.completed'));
        setReloadKey(k => k + 1);
      } else {
        const data = await res.json().catch(() => ({}));
        alert(data.message || t('refund_queue.error'));
      }
    } catch (error) {
      console.error(error);
      alert(t('refund_queue.error'));
    }
  };

  const CreateList = () => {
    return list.map((rq, index) => <Tr key={index} rq={rq} onComplete={onComplete} />)
  }

  return (
    <>
      <Header />
      <SideMenu />
      <div className="refund-queue">
        <div className="refund-queue-title">{t('refund_queue.title')}</div>
        <div className='clearfix'></div>

        {pendingCount > 0 &&
          <div className="refund-queue-alert">{t('refund_queue.pending_alert', { count: pendingCount })}</div>
        }

        <div className="refund-queue-search">
          <table className="refund-queue-search-table">
            <tbody>
              <tr>
                <td>
                  <select className="refund-queue-search-input" value={state} onChange={(e) => setState(e.target.value)}>
                    <option value="">{t('refund_queue.state_all')}</option>
                    <option value="pending">{t('refund_queue.state_pending')}</option>
                    <option value="completed">{t('refund_queue.state_completed')}</option>
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="refund-queue-content">
          <table className="refund-queue-content-table">
            <thead>
              <tr>
                <th>{t('refund_queue.id')}</th>
                <th>{t('refund_queue.order_no')}</th>
                <th>{t('refund_queue.amount_cny')}</th>
                <th>{t('refund_queue.wechat_transaction_id')}</th>
                <th>{t('refund_queue.state')}</th>
                <th>{t('refund_queue.created_at')}</th>
                <th>{t('refund_queue.refunded_at')}</th>
                <th>{t('refund_queue.action')}</th>
              </tr>
            </thead>
            <tbody>
              <CreateList />
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}

export default RefundQueue
